<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
  >
    <path
      :class="color"
      :stroke-width="weight"
      stroke-linecap="round"
      stroke-linejoin="round"
      :d="pathStart+'l -1,-1 -4,4 -4,-4 -1,1 4,4 -4,4 1,1 4,-4 4,4 1,-1 -4,-4Z'"
    />
  </svg>
</template>

<script>
export default {
  name: 'XMarkIcon',
  props: {
    color: {
      type: String,
      default: 'gray',
    },
    weight: {
      type: Number,
      default: 0.2,
    },
  },
  computed: {
    viewBox() {
      return `0 0 ${10 + (2 * this.weight)} ${10 + (2 * this.weight)}`;
    },
    pathStart() {
      return `M${10 + this.weight},${1 + this.weight}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.gray {
  fill: main.$npGray;
  stroke: main.$npGray;
}
.orange {
  fill: main.$npOrange;
  stroke: main.$npOrange;
}
.red {
  fill: #a82323;
  stroke: #a82323;
}
</style>
